import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { AboutSection } from './AboutSection.tsx';
import './settings-about.css';

// "About" on the settings screen, last: the platform's brand gives the text,
// the same the landing page's footer shows.
export function setup(app: PiletApi) {
  const brand = app.tryGetApi('brand');
  app.registerExtension('settings.sections', () => <AboutSection name={brand.name} about={brand.about} />, { order: 100 });
}
